import React from "react";

const LikedVideosSvg = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 1.5V14.5H18.5V1.5H1.5ZM1 0C0.447715 0 0 0.447715 0 1V15C0 15.5523 0.447716 16 1 16H19C19.5523 16 20 15.5523 20 15V1C20 0.447715 19.5523 0 19 0H1Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8L8 4L8 12L14 8ZM11.2958 8L9.5 6.80278L9.5 9.19722L11.2958 8Z"
        fill="white"
      />
    </svg>
  );
};

export default LikedVideosSvg;
